import { TableHead, TableRow } from '@mui/material';
import CellHeader from '../CellHeader';

const TableHeader: React.FC<{ headers: string[] }> = ({ headers }) => (
  <TableHead>
    <TableRow>
      {headers.map((header, index) => (
        <CellHeader key={index} title={header} />
      ))}
    </TableRow>
  </TableHead>
);

export default TableHeader;
